@let usernameValue = username();

<rt-dialog-header
  [heading]="'tlc.members.edit_member.change_login_method_dialog.title' | translate"
/>
<rt-dialog-body layout-vertical variant="default white">
  <rt-label margin-bottom-small-x>
    {{ 'tlc.members.edit_member.change_login_method_dialog.form_title' | translate }}</rt-label
  >

  <rt-group margin-bottom>
    <rt-group variant="vertical">
      <rt-radio
        [checked]="checkboxValue()"
        [hasAlignItemsStart]="true"
        (click)="onValueChange(true)"
        margin-bottom-small
      >
        <div layout-vertical>
          <span text-bold text-color>
            {{
              'tlc.members.edit_member.change_login_method_dialog.username_label'
                | translate: { username: usernameValue }
            }}
          </span>
          <span text-default text-color>{{
            'tlc.members.edit_member.change_login_method_dialog.username_description' | translate
          }}</span>
        </div>
      </rt-radio>
      <rt-radio
        [checked]="!checkboxValue()"
        [hasAlignItemsStart]="true"
        (click)="onValueChange(false)"
      >
        <div layout-vertical>
          <span text-bold text-color>
            {{ 'tlc.members.edit_member.change_login_method_dialog.email_label' | translate }}
          </span>
          <span text-default text-color>{{
            'tlc.members.edit_member.change_login_method_dialog.email_description' | translate
          }}</span>
        </div>
      </rt-radio>
    </rt-group>
  </rt-group>

  @if (!checkboxValue()) {
    <div layout-vertical>
      <rt-label margin-bottom-small-xx>
        {{ 'tlc.members.edit_member.change_login_method_dialog.login_email_title' | translate }}
      </rt-label>

      {{ 'tlc.members.edit_member.change_login_method_dialog.login_email_description' | translate }}

      <form [formGroup]="form" margin-bottom margin-top-small-xx>
        <rt-form-field>
          <rt-input formControlName="email" variant="rounded" />
        </rt-form-field>
      </form>

      <rt-infobox [isDismissible]="false" type="warning" iconName="warning">
        {{ 'tlc.members.edit_member.change_login_method_dialog.login_email_infobox' | translate }}
      </rt-infobox>
    </div>
  }
</rt-dialog-body>
<rt-dialog-footer variant="white">
  <rt-button (click)="cancel()" variant="plain" margin-right-small>{{
    'tlc.common.cancel' | translate
  }}</rt-button>
  <rt-button (click)="save()" [loading]="loading()" [disabled]="form.invalid" variant="primary"
    >{{ 'tlc.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
